import React from "react";
import { Table } from "react-bootstrap";
import { formatNumberToString, roundNumber } from "../../utils/Utils";
import { useSelector } from "react-redux";
const AssetsList = (props) => {
  const theme =  useSelector((state) => state.settings.selected_theme) || 'light';
  const { coins, isTotal,t ,showImage} = props;

  const coinItems =
    coins &&
    coins.map((item, index) => {
      return (
        <tr key={index} className={`theme-border ${theme}`}>
          <td className="text-left">
            {showImage && 
            <img
              src={item.image || require("../../images/coin_pl.png")}
              height={15}
            /> }
            <span className="ml-2">
              {item.name} ({item.symbol})
            </span>
          </td>
          <td>
            {formatNumberToString(item.amount)} {item.symbol}
          </td>
          <td>{roundNumber(item.total)} USD</td>
        </tr>
      );
    });
  return (
    <div>
      <Table  responsive className={`mt-4 theme-bg ${theme}`}>
        <thead>
          <tr>
            <th className="text-left">Asset</th>
            <th>{t("balance")}</th>
            <th>{t("margin-balance")}</th>
          </tr>
        </thead>
        <tbody>{coinItems}</tbody>
      </Table>
    </div>
  );
};

export default AssetsList;
